import { useEffect, useState, useRef } from 'react';
import '../styles/pages/AboutUs.scss'
import axios from 'axios';
import { SERVER } from '../hooks/config';

const AboutUs = () => {
    const [video, setVideo] = useState();
    const [isPlaying, setIsPlaying] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);
    const videoRef = useRef(null);

    useEffect(() => {
        fetchVideo();
    }, []);

    const fetchVideo = async () => {
        try {
            setLoading(true);
            setError(false);
            const response = await axios.get(`${SERVER}/aboutus/getVideo`);
            if (response.data.videoPath) {
                setVideo(response.data.videoPath);
            }
        } catch (err) {
            console.log(err);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    const togglePlay = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
                setIsPlaying(false);
            } else {
                videoRef.current.play();
                setIsPlaying(true);
            }
        }
    };

    return(
        <div className="aboutus">
            <div className='aboutus-title'>
                à propos
            </div>
            <div className='history'>
                <div className='history-title'>
                    <h2> L’histoire derrière </h2>
                    <h3> Michkette </h3>
                </div>
                <div className='history-content'>
                    <span>Je m’appelle Rabeb, passionnée de création et maman de la petite Michkette, à qui j’ai emprunté le nom pour lancer cette aventure.</span>
                    <span>Michkette.tn est née d’un rêve simple : créer des bijoux et des cadeaux uniques, personnalisés avec amour, qui ont une histoire, une âme et une touche tunisienne.</span>
                </div>
            </div>
            <div className='creations'>
                <div className='creations-title'>
                    <h2> Des créations qui racontent une histoire </h2>
                </div>
                <div className='creations-content'>
                    <span>Tout a commencé dans mon petit atelier, entre outils, croquis et inspirations quotidiennes. J’ai voulu imaginer une marque artisanale où chaque pièce raconte une émotion, une attention, un moment de vie.</span>
                    <span>Ce projet, c’est plus qu’une marque : c’est une déclaration d’amour à l’art du fait-main, au raffinement discret et à la joie d’offrir du vrai.</span>
                    <span>Bienvenue dans mon univers. Ici, chaque création est pensée avec soin, conçue pour marquer un souvenir ou simplement faire plaisir — de manière authentique, élégante et 100 % tunisienne.</span>
                </div>
            </div>

            {error ? (
                <div className="aboutus-video-error">
                    <p>Impossible de charger la vidéo pour le moment.</p>
                    <button onClick={fetchVideo} className="retry-button">Réessayer</button>
                </div>
            ) : loading ? (
                <div className="aboutus-video-loading">Chargement de la vidéo...</div>
            ) : video ? (
                <div className="aboutus-video-container">
                    <video 
                        ref={videoRef} 
                        width="100%" 
                        className="aboutus-video"
                        onClick={togglePlay}
                    >
                        <source src={`${SERVER}${video}`} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                    {!isPlaying && (
                        <button className="custom-play-btn" onClick={togglePlay}>
                            ▶
                        </button>
                    )}
                </div>
            ) : null}
        </div>
    )
}

export default AboutUs;